// DropdownLink.vue
<template>
  <div class="dropdown">
    <div @click="toggleDropdown">
      <slot name="link"></slot>
    </div>
    <div v-if="isOpen" class="dropdown-content">
      <slot name="dropdown"></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style scoped>
.dropdown-content {
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
}
</style>
